export default __webpack_public_path__ + "static/media/empty-place-avatar.cd5ba14c.jpg";